@if (!!logged && mainMessage.length) {
  <app-marquee [text]="mainMessage"> </app-marquee>
}

<!-- Menu Lateral -->
<p-sidebar
  [(visible)]="showMenu"
  [fullScreen]="true"
  class="app-header--left-menu"
  [ngClass]="{ app: !!isApp }"
  (onShow)="resetMenu()">
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <div
        class="cursor-pointer app-header--left-menu--exit"
        (click)="showMenu = false"
        (keyup.enter)="showMenu = false"
        tabindex="1">
        <app-cigna-icon icon="cross"></app-cigna-icon>
      </div>
      <div
        class="app-header--left-menu--logo cursor-pointer"
        (keyup.enter)="goHome()"
        tabindex="1"
        (click)="goHome()">
        <svg class="logo" alt="logo cigna">
          <use href="./assets/images/svg/images-sprite.svg#logo" />
        </svg>
      </div>
    </div>
  </ng-template>
  @if (menu === -1) {
    <div>
      <div class="app-header--left-menu--item inicio align-content-center cursor-pointer">
        <span (click)="goHome()" (keyup.enter)="goHome()" tabindex="1">
          {{ 'headerLog.inicio' | translate }}
        </span>
      </div>
      @for (item of menuItems; track item; let i = $index) {
        @if (!!item.label && (item.visible || item.visible === undefined)) {
          <div
            class="flex gap-2 app-header--mr cursor-pointer"
            (click)="setMenu(i)"
            (keyup.enter)="setMenu(i)"
            tabindex="1">
            <div
              class="app-header--left-menu--item flex justify-content-between align-items-center">
              <span class="m-bold">{{ item.label! | translate }}</span>
              <app-cigna-icon icon="chevron-right"></app-cigna-icon>
            </div>
          </div>
        }
      }
      <div class="flex justify-content-left mt-4">
        <app-insured-dropdown
          class="display-only-on-phone"
          (authorizedClicked)="authorizedClicked()"></app-insured-dropdown>
      </div>
    </div>
  }
  @if (menu >= 0) {
    <div>
      <div
        class="flex gap-2 mr-6 cursor-pointer app-header--left-menu--item goback align-items-center"
        (click)="setMenu(-1)"
        (keyup.enter)="setMenu(-1)"
        tabindex="1">
        <app-cigna-icon icon="chevron-left"></app-cigna-icon>
        <span class="m-bold">{{ menuItems[menu].label! | translate }}</span>
      </div>
      @for (item of menuItems[menu].items; track item) {
        @if (item.visible || item.visible === undefined) {
          <div
            class="app-header--left-menu--item flex gap-2 mr-6 cursor-pointer align-items-center"
            [ngClass]="{ 'app-header--left-menu--item--disabled': item.disabled }"
            (click)="goToMenuOption($event, item)"
            (keyup.enter)="goToMenuOption($event, item)"
            tabindex="1">
            <app-cigna-icon [icon]="item.icon!"></app-cigna-icon>
            <div class="flex flex-column">
              <div class="flex">
                <span class="m-bold">{{ item.label! | translate }}</span>
              </div>
              <div class="flex app-header--logged--menu--sub--sub-menu">
                <span class="s-regular">{{ item['subItem']! | translate }}</span>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</p-sidebar>

<!-- Cabecera no logado-->
@if (!logged) {
  <div
    class="app-header--not-logged w-full"
    [ngClass]="{ 'app-header--not-logged--logout': !!logout }">
    <div class="flex justify-content-between flex-wrap">
      <div
        class="flex align-items-center justify-content-center app-header--not-logged--logo cursor-pointer"
        (keyup.enter)="goHome()"
        tabindex="1"
        (click)="goHome()">
        <svg class="logo" alt="logo cigna">
          <use href="./assets/images/svg/images-sprite.svg#logo" />
        </svg>
      </div>
      <div class="flex gap-3 app-header--not-logged--main-container">
        <nav>
          <ul class="app-header--not-logged--menu flex align-items-center">
            <div class="app-header--not-logged--menu--language flex align-items-center">
              <app-cigna-icon icon="world"></app-cigna-icon>
            </div>
            <p-dropdown
              class="app-header--not-logged--menu--dropdown generic-focus"
              tabindex="1"
              [options]="languages"
              optionLabel="name"
              [(ngModel)]="currentLanguage"
              (onChange)="languageChange($event)">
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center m-bold primary-color">
                  {{ currentLanguage.name }}
                </div>
              </ng-template>
              <ng-template let-language pTemplate="item">
                <div class="flex align-items-center m-bold mt-2 mb-2">
                  {{ language.name }}
                </div>
              </ng-template>
            </p-dropdown>
            <button
              pButton
              class="app-header--not-logged--menu--button mr-0 medium-40 telefono display-none-phone"
              tabindex="1"
              severity="secondary"
              (click)="contacto()">
              <app-cigna-icon icon="phone"></app-cigna-icon>
              <span class="display-none-phone">{{ 'header.contact' | translate }}</span>
            </button>
            <button
              pButton
              class="app-header--not-logged--menu--buttonMobile mr-0 medium-40 telefono"
              severity="secondary"
              (click)="contactoMovil()">
              <app-cigna-icon icon="phone"></app-cigna-icon>
              <span class="display-none-phone">{{ 'header.contact' | translate }}</span>
            </button>
          </ul>
        </nav>
      </div>
    </div>
  </div>
}

<!-- Cabecera logado-->
@if (!!logged) {
  <div class="app-header--logged">
    <div
      class="flex w-full align-items-center justify-content-between app-header--logged--main-container">
      <div class="flex align-items-center justify-content-left app-header--logged--left">
        @if (!logData.isAdmin) {
          <div
            class="app-header--logged--left--menuMobil cursor-pointer display-only-under-desktop"
            (click)="showMenu = true"
            (keyup.enter)="showMenu = true"
            tabindex="1">
            <app-cigna-icon icon="menuMobile"></app-cigna-icon>
          </div>
        }
        <div
          class="app-header--logged--left--logo cursor-pointer"
          (keyup.enter)="goHome()"
          tabindex="1"
          (click)="goHome()">
          <svg class="logo" alt="logo cigna">
            <use href="./assets/images/svg/images-sprite.svg#logo" />
          </svg>
        </div>
      </div>
      <div class="flex w-full app-header--logged--right">
        <nav class="app-header--logged--container1">
          <ul class="flex-1 app-header--logged--menu flex">
            <div class="app-header--logged--menu--button flex align-items-center">
              <div class="app-header--logged--menu--button--menu1 flex align-items-center">
                @if (!logData.isAdmin && !logData.isPremember) {
                  <div
                    class="relative app-header--logged--menu--popup app-header--logged--menu--opciones"
                    [ngClass]="{
                      'app-header--logged--menu--popup--nodrcigna': !getDrCigna(),
                      'app-header--logged--menu--popup--auto':
                        !polizaSalud || !isAppointmentsAvailable,
                      'menu-active-selected':
                        activeSelected === 'telemedicina' && !menuOpcion[activeSelected],
                    }">
                    <div
                      class="flex gap-2 cursor-pointer"
                      (click)="menu1.toggle($event)"
                      (keyup.enter)="menu1.toggle($event)"
                      tabindex="1">
                      <span
                        [ngClass]="{
                          'menu-active':
                            menuOpcion['telemedicina'] || activeSelected === 'telemedicina',
                        }"
                        class="m-regular titulo">
                        {{ menuItems[0].label! | translate }}
                      </span>
                      <app-cigna-icon icon="chevron-down"></app-cigna-icon>
                    </div>
                    <p-menu
                      #menu1
                      [popup]="true"
                      (onShow)="openMenu('telemedicina')"
                      (onHide)="closeMenu('telemedicina')"
                      [model]="menuItems[0].items"
                      class="app-header--logged--menu">
                      <ng-template pTemplate="item" let-item>
                        <a class="flex flex-wrap app-header--logged--menu--sub">
                          <app-cigna-icon [icon]="item.icon"></app-cigna-icon>
                          <div class="flex flex-column">
                            <div class="flex">
                              <span>{{ item.label | translate }}</span>
                            </div>
                            <div class="flex app-header--logged--menu--sub--sub-menu">
                              <span class="s-regular">{{ item.subItem | translate }}</span>
                            </div>
                          </div>
                        </a>
                      </ng-template>
                    </p-menu>
                  </div>
                }
                @if (!logData.isAdmin) {
                  <div
                    class="relative app-header--logged--menu--popup--gestiones app-header--logged--menu--opciones"
                    [ngClass]="{
                      nivel1: numItemsGestiones < 3,
                      nivel2: numItemsGestiones > 2 && numItemsGestiones < 5,
                      'menu-active-selected':
                        activeSelected === 'gestiones' && !menuOpcion[activeSelected],
                    }">
                    <div
                      class="flex gap-2 cursor-pointer"
                      (click)="menu2.toggle($event)"
                      (keyup.enter)="menu2.toggle($event)"
                      tabindex="1">
                      <span
                        [ngClass]="{
                          'menu-active': menuOpcion['gestiones'] || activeSelected === 'gestiones',
                        }"
                        class="m-regular titulo">
                        {{ menuItems[1].label! | translate }}
                      </span>
                      <app-cigna-icon icon="chevron-down"></app-cigna-icon>
                    </div>
                    <p-menu
                      #menu2
                      [popup]="true"
                      (onShow)="openMenu('gestiones')"
                      (onHide)="closeMenu('gestiones')"
                      [model]="menuItems[1].items"
                      class="app-header--logged--menu">
                      <ng-template pTemplate="item" let-item>
                        <a
                          class="flex menu-custom app-header--logged--menu--sub"
                          [ngClass]="
                            !logData.isPremember && !!tieneChipcard ? 'not-premember' : 'premember'
                          ">
                          <div
                            class="flex align-items-center justify-content-center relative"
                            style="padding: 10px">
                            <app-cigna-icon [icon]="item.icon"></app-cigna-icon>
                            <span>{{ item.label | translate }}</span>
                          </div>
                        </a>
                      </ng-template>
                    </p-menu>
                  </div>
                }
                @if (!logData.isAdmin) {
                  <div
                    class="relative app-header--logged--menu--popup--soporte app-header--logged--menu--opciones"
                    [ngClass]="{
                      'menu-premember': logData.isPremember,
                      'menu-active-selected':
                        activeSelected === 'soporte' && !menuOpcion[activeSelected],
                    }">
                    <div
                      class="flex gap-2 cursor-pointer"
                      (click)="menu3.toggle($event)"
                      (keyup.enter)="menu3.toggle($event)"
                      tabindex="1">
                      <span
                        [ngClass]="{
                          'menu-active': menuOpcion['soporte'] || activeSelected === 'soporte',
                        }"
                        class="m-regular titulo">
                        {{ menuItems[2].label! | translate }}
                      </span>
                      <app-cigna-icon icon="chevron-down"></app-cigna-icon>
                    </div>
                    <p-menu
                      #menu3
                      [popup]="true"
                      (onShow)="openMenu('soporte')"
                      (onHide)="closeMenu('soporte')"
                      [model]="menuItems[2].items"
                      class="app-header--logged--menu">
                      <ng-template pTemplate="item" let-item>
                        <a class="flex flex-wrap app-header--logged--menu--sub">
                          <app-cigna-icon [icon]="item.icon"></app-cigna-icon>
                          <span>{{ item.label | translate }}</span>
                        </a>
                      </ng-template>
                    </p-menu>
                  </div>
                }
                @if (!logData.isAdmin) {
                  <div
                    class="relative app-header--logged--menu--popup--mas app-header--logged--menu--opciones"
                    [ngClass]="{
                      'menu-premember': logData.isPremember,
                      'menu-active-selected':
                        activeSelected === 'mas' && !menuOpcion[activeSelected],
                    }">
                    <div
                      class="flex gap-2 cursor-pointer"
                      (click)="menu4.toggle($event)"
                      (keyup.enter)="menu4.toggle($event)"
                      tabindex="1">
                      <span
                        [ngClass]="{
                          'menu-active': menuOpcion['mas'] || activeSelected === 'mas',
                        }"
                        class="m-regular titulo">
                        {{ menuItems[3].label! | translate }}
                      </span>
                      <app-cigna-icon icon="chevron-down"></app-cigna-icon>
                    </div>
                    <p-menu
                      #menu4
                      [popup]="true"
                      (onShow)="openMenu('mas')"
                      (onHide)="closeMenu('mas')"
                      [model]="menuItems[3].items"
                      class="app-header--logged--menu">
                      <ng-template pTemplate="item" let-item>
                        <a
                          class="flex flex-wrap app-header--logged--menu--sub"
                          style="width: 300px">
                          <app-cigna-icon [icon]="item.icon"></app-cigna-icon>
                          <span>{{ item.label | translate }}</span>
                        </a>
                      </ng-template>
                    </p-menu>
                  </div>
                }
              </div>
            </div>
          </ul>
        </nav>
        <div class="flex">
          <nav class="flex-1 app-header--logged--container2">
            <ul class="flex-1 app-header--logged--menu flex">
              <div class="app-header--logged--menu--buttonAsegurado flex align-items-center">
                @if (!logData.isAdmin) {
                  <app-insured-dropdown class="mr-5"></app-insured-dropdown>
                }
                @if (logData.isAuthorized && !logData.isAdmin) {
                  <app-cigna-icon
                    class="relative app-header--logged--menu--rectangle"
                    icon="rectangle"></app-cigna-icon>
                }
              </div>
            </ul>
          </nav>
          <nav class="flex-1 app-header--logged--container3">
            <ul class="flex-1 app-header--logged--menu flex">
              <div class="app-header--logged--menu--buttonAsegurado flex align-items-center">
                <!-- <app-cigna-icon class="mr-3" icon="notify"></app-cigna-icon> -->
                <app-notifications class="mr-3" tabindex="1"></app-notifications>
                <div class="app-header--logged--menu--button--menu1 flex align-items-center">
                  <div
                    class="relative app-header--logged--menu--popup--perfil"
                    [ngClass]="{
                      'menu-premember': logData.isPremember,
                      'menu-admin': logData.isAdmin,
                      'menu-app': isApp,
                    }">
                    <div
                      class="flex gap-2 cursor-pointer"
                      (click)="menu6.toggle($event)"
                      (keyup.enter)="menu6.toggle($event)"
                      tabindex="1">
                      <span
                        [ngClass]="{
                          'menu-active': menuOpcion['perfil'],
                          'app-header--circle--blue': menuOpcion['perfil'],
                        }"
                        class="relative app-header--circle">
                        {{ iniciales }}
                      </span>
                      <app-cigna-icon
                        class="relative app-header--logged--menu--downIcon"
                        icon="chevron-down"></app-cigna-icon>
                    </div>
                    <p-menu
                      #menu6
                      [popup]="true"
                      (onShow)="openMenu('perfil')"
                      (onHide)="closeMenu('perfil')"
                      [model]="menuItems[4].items">
                      <ng-template pTemplate="item" let-item>
                        <a
                          class="flex flex-nowrap justify-content-between app-header--logged--menu--sub"
                          tabindex="1"
                          (click)="dropdownDes($event, item.label)"
                          (keyup.enter)="dropdownDes($event, item.label)">
                          <div class="flex">
                            <app-cigna-icon [icon]="item.icon"></app-cigna-icon>
                            <span>{{ item.label | translate }}</span>
                          </div>
                          @if (item.label === 'headerLog.opcionPerfil.idioma') {
                            <p-dropdown
                              #dropdown
                              (click)="noCerrar($event)"
                              class="app-header--logged--menu--dropdown"
                              [options]="languages"
                              optionLabel="name"
                              [(ngModel)]="currentLanguage"
                              (onChange)="languageChange($event)">
                              <ng-template pTemplate="selectedItem">
                                <div class="flex align-items-center m-bold primary-color">
                                  {{ currentLanguage.name }}
                                </div>
                              </ng-template>
                              <ng-template let-language pTemplate="item">
                                <div
                                  class="flex align-items-center m-bold mt-2 mb-2 selector-name">
                                  {{ language.name }}
                                </div>
                              </ng-template>
                            </p-dropdown>
                          }
                        </a>
                      </ng-template>
                      @if (logData.previousLastLogin) {
                        <ng-template pTemplate="end">
                          <div class="app-header--logged--menu--lastaccess">
                            <span class="">
                              {{ 'headerLog.opcionPerfil.lastaccess.lastaccess' | translate }}:
                              {{ logData.previousLastLogin | date: 'dd/MM/yyyy' }}
                              {{ 'headerLog.opcionPerfil.lastaccess.at' | translate }}
                              {{ logData.previousLastLogin | date: 'HH:mm:ss' }}
                            </span>
                          </div>
                        </ng-template>
                      }
                    </p-menu>
                  </div>
                </div>
              </div>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
}
